import {TechnicalIssuePriority, TechnicalIssueType} from '@services/TechnicalSupport/types';

export const technicalIssueTypePlaceholder = {
    [TechnicalIssueType.ERROR]: 'technicalSupport.typeErrorDesc',
    [TechnicalIssueType.SUGGESTION]: 'technicalSupport.typeSuggectionDesc',
    [TechnicalIssueType.ADD_NCI]: 'technicalSupport.typeAddNciDesc',
};

export const technicalIssuePrioritySubTitle = {
    [TechnicalIssuePriority.HIGH]: 'technicalSupport.priorityHighDesc',
    [TechnicalIssuePriority.MEDIUM]: 'technicalSupport.priorityMediumDesc',
    [TechnicalIssuePriority.LOW]: 'technicalSupport.priorityLowDesc',
};

export const technicalIssueDefaultValues = {
    type: TechnicalIssueType.ERROR,
    priority: TechnicalIssuePriority.HIGH,
    description: '',
    section: '',
    files: [],
};
